import React from "react"
import { ResultPaginationNextPrevProps } from "@usereactify/search"
import { Button } from "@app/scripts/react-general-components/Button"

type PaginationNextPageProps = React.ComponentProps<
  NonNullable<ResultPaginationNextPrevProps["render"]>
> & {
  pageSize: number;
}

export const PaginationNextPage: React.FC<PaginationNextPageProps> = (props) => {
  return (
    <div className="main-collection-product-grid__loadmore">
      {`Showing page ${props?.currentPage + 1} of ${props?.totalPages}`}

      <div className="flex space-x-4">
        <Button
          className="main-collection-product-grid__loadmore-button"
          onClick={props.handlePreviousPage}
          disabled={!props.hasPreviousPage}
          label={"Prev"}
          variant="secondary"
        />
        <Button
          className="main-collection-product-grid__loadmore-button"
          onClick={props.handleNextPage}
          disabled={!props.hasNextPage}
          label={"Next"}
          variant="secondary"
        />
      </div>
    </div>
  )
}

